import { DownloadOutlined } from '@ant-design/icons'
import { Button, ButtonProps, message } from 'antd'
import { useState } from 'react'

import { downloadBlob, generateFilename } from 'utils/download-file'
import { logError } from 'utils/logger'

interface ButtonExportProps extends Omit<ButtonProps, 'onClick' | 'loading'> {
  /** Calls the BE export API (responseType: 'blob'); the CSV is built by the BE. */
  onExport: () => Promise<{ data: BlobPart }>
  /** Part of the downloaded file name: export_<fileType>_<yyyy-mm-dd>.csv */
  fileType: string
}

const ButtonExport = ({ onExport, fileType, children = 'Export', ...rest }: ButtonExportProps) => {
  const [exporting, setExporting] = useState(false)

  const handleExport = async () => {
    try {
      setExporting(true)
      const res = await onExport()
      downloadBlob(res.data, generateFilename(fileType))
    } catch (error) {
      logError(`Export ${fileType} failed`, error)
      message.error('Failed to export data')
    } finally {
      setExporting(false)
    }
  }

  return (
    <Button icon={<DownloadOutlined />} loading={exporting} onClick={handleExport} {...rest}>
      {children}
    </Button>
  )
}

export default ButtonExport
